<template>
  <div v-if="render" class="main-page-box">
    <div class="back-box" @click="back">
      <i class="fas fa-chevron-left fa-fw"></i>
      BACK
    </div>

    <div class="dtls-page">
      <div class="dtls-hero">
        <!-- <div class="gallery-container">
          <div class="gallery-slider">
            <img id="galleryImage" :src="view.Images[0]" v-if="view.Images && view.Images.length">
          </div>
          <div class="dots-container" id="dotsContainer"></div>
        </div> -->
        <image-slider :imgs="view.Images" />

        <div class="hero-overlay"></div>
        <div class="hero-content">
          <div class="hero-badge">Hotel</div>
          <div class="hero-title">{{ view.HotelName }}</div>
          <div class="hero-meta">
            <span v-if="view.Address">
              <i class="fas fa-map-marker-alt fa-fw"></i>
              {{ view.Address }}
            </span>
            <!-- <span v-if="view.Duration.trim()">
              <i class="far fa-clock fa-fw"></i>
              {{ view.Duration }}
            </span> -->
          </div>
        </div>
      </div>

      <div class="info-bar">
        <div class="info-card" v-if="view.first_room_details.room_name">
          <div class="info-icon">
            <i class="fas fa-bed fa-fw"></i>
          </div>
          <div>
            <label>Room</label>
            <p>{{ view.first_room_details.room_name }}</p>
          </div>
        </div>
        <div class="info-card" v-if="view.StarRating">
          <div class="info-icon">
            <i class="fas fa-star fa-fw"></i>
          </div>
          <div>
            <label>Rating</label>
            <p>{{ view.StarRating }}</p>
          </div>
        </div>
        <div class="info-card" v-if="view.CheckInTime">
          <div class="info-icon">
            <i class="far fa-calendar fa-fw"></i>
          </div>
          <div>
            <label>Check In<span v-if="view.CheckOutTime"> / Out</span></label>
            <p>
              {{ formatDate(view.checkin) }} <span class="in-time">{{ view.CheckInTime }}</span>
              <span v-if="view.CheckOutTime"> / {{ formatDate(view.checkout) }} <span class="in-time">{{ view.CheckOutTime }}</span></span>
            </p>
          </div>
        </div>
        <!-- <div class="info-card">
          <div class="info-icon">
            <i class="fas fa-users fa-fw"></i>
          </div>
          <div>
            <label>Travelers</label>
            <p>Up to {{ view.MaxTravellerCount }}</p>
          </div>
        </div> -->
        <!-- <div class="info-card" v-if="view.VoucherOption_List">
          <div class="info-icon">
            <i class="far fa-file-alt fa-fw"></i>
          </div>
          <div>
            <label>Voucher Type</label>
            <p>{{ view.VoucherOption_List.type }}</p>
          </div>
        </div> -->
      </div>
    </div>

    <div class="dtls-two-col">
      <div class="dtls-two-main">
        <div class="section-box">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>About This Hotel</label>
          </div>
          <div class="description-text" v-html="view.Description"></div>
        </div>

        <div class="section-box" v-if="view.SpecialInstructions">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>Special Instruction</label>
          </div>
          <div class="description-text" v-html="view.SpecialInstructions"></div>
        </div>

        <div class="section-box" v-if="view.HotelFacilities && view.HotelFacilities.length">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>Facilities</label>
          </div>
          <div class="description-text" v-for="(inc, i) in view.HotelFacilities" :key="i" v-show="i < 7 || showAllFacility">
            <i class="fas fa-check fa-fw"></i>
            {{ inc }}
          </div>
          <span class="show-all" v-if="view.HotelFacilities.length > 7 && !showAllFacility" @click="showAllFacility = true">Show All</span>
        </div>

        <!-- <div class="section-box" v-if="view.Exclusions && view.Exclusions.length">
          <div class="sb-header">
            <div class="sb-icon">
              <i class="fas fa-info-circle fa-fw"></i>
            </div>
            <label>Whats NOT Included</label>
          </div>
          <div class="description-text" v-for="inc in view.Exclusions">
            <i class="fas fa-times fa-fw"></i>
            {{ inc.description }}
          </div>
        </div> -->
      </div>

      <div class="dtls-two-side">
        <div class="price-section">
          <div class="price-label">Price</div>
          <div class="price-value">
            {{ currencySymbol[currency.code] }}
            {{ applyCurrency(view.first_room_details.Price, false) }} 
            <span>{{ currency.code }}</span>
          </div>
          <div class="price-note">for {{ dayCount(view) }}</div>
          <button class="km-btn" @click="bookNow">Book Now</button>
        </div>

        <!-- <div class="side-card" v-if="view.Cancellation_available">
          <div class="side-label">
            <i class="far fa-check-circle fa-fw"></i>
            Cancellation Policy
          </div>
          <p>{{ view.Cancellation_Policy }}</p>
        </div> -->
      </div>

    </div>

    <!-- <traveller-modal :trData="view" ref="trvModal" /> -->
  </div>
</template>

<script>
/* global CONFIG */
import currencySymbol from '@/data/currency.js'
import xcurrency from '@/modules/api/currency'
import moment from 'moment-timezone'
import TravellerModal from './traveller-modal'
import ImageSlider from '@/components/Global/ImageSlider'

export default {
  components: { TravellerModal, ImageSlider },
  data () {
    return {
      render: false,
      currencySymbol: currencySymbol,
      showAllFacility: false
    }
  },
  computed: {
    hotel () { return this.$store.state.hotel },
    view () { return this.hotel.view },
    currency () { return this.$store.state.other.currency }
  },
  methods: {
    backToSearch () {
      this.$router.push('/search')
      this.$store.commit('hotel/setData', {view: null})
    },
    back () {
      this.$router.push('/hotel')
      this.$store.commit('hotel/setData', {view: null})
    },
    timeFormat (x) {
      return moment(x, 'HH:mm').format('hh:mmA')
    },
    formatDate (x) {
      if (!x) return ''
      return moment(x, 'DD-MM-YYYY').format('MMM DD')
    },
    dayCount (x) {
      let start = moment(x.checkin, 'DD-MM-YYYY')
      let end = moment(x.checkout, 'DD-MM-YYYY')
      let diff = end.diff(start, 'days')
      return diff > 1 ? `${diff} nights` : '1 night'
    },
    // bookNow () {
    //   // if (this.$refs.trvModal) this.$refs.trvModal.showModal()
    // },
    bookNow () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.show = false

      self.$sdk.post2(`${CONFIG.d2dAPI}/hotel/rooms`, {
        HotelCode: self.view.HotelCode,
        ResultToken: self.hotel.selected.ResultToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (!r.Status) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.Message
          })
          return
        }
        self.$store.commit('hotel/setRoomsData', {data: r.RoomList.GetHotelRoomResult})
        self.$router.push('/hotel/rooms')
      })
    },
    price (data) {
      let price = data.PublishedPrice / this.currency.list[data.CurrencyCode]
      return price.toFixed(2)
    },
    applyCurrency (data, useSymbol = true, noComma = false) {
      let x = data.PublishedPrice
      if (data.Currency !== 'USD' && this.currency.code !== data.CurrencyCode) {
        x = x / this.currency.list[data.CurrencyCode]
        x = x.toString().replace(/[',']/g, '')
        x = parseFloat(x)
        x = x * this.currency.value
      }
      return xcurrency.format({
        code: this.currency.code,
        val: x.toFixed(2)
      }, useSymbol, noComma)
    }
  },
  mounted () {
    this.render = false
    this.$store.commit('global/setAuthData', {action: ''})
    if (!this.hotel.view) {
      this.backToSearch()
      return
    }
    this.render = true
    this.$store.commit('global/setLoaderData', {show: false})
  }
}
</script>

<style lang="scss" scoped>
.main-page-box{
  // background: #fafafa;
  // border: 1px solid #ddd;
  padding: 15px 20px;
  margin-bottom: 20px;
}
.back-box{
  color: #4a4a6a;
  letter-spacing: .7px;
  margin-bottom: 10px;
  cursor: pointer;

  &:hover{
    color: #ff9c09;
  }
}

.dtls-hero{
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);

  img{
    width: 100%;
    height: 420px;
    object-fit: cover;
    display: block;
  }
}

.hero-overlay{
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(26, 26, 46, 0.85) 0%, rgba(26, 26, 46, 0.2) 50%, transparent 100%);
  display: none;
}
.hero-content{
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // right: 0;
  padding: 20px 30px;
}
.hero-badge{
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #ECAE20;
  color: #1a1a2e;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 6px 14px;
  border-radius: 30px;
  margin-bottom: 8px;

  &::before{
    content: '';
    width: 6px;
    height: 6px;
    background: #1a1a2e;
    border-radius: 50%;
  }
}
.hero-title{
  font-size: 36px;
  font-weight: 700;
  color: #333;
  margin-bottom: 8px;
  line-height: 1.2;
}
.hero-meta{
  display: flex;
  align-items: center;
  gap: 20px;
  color: #555;
  font-size: 14px;
  flex-wrap: wrap;
  letter-spacing: .4px;
}

.info-bar{
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}
.info-card{
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border: 1px solid #ffe19c;
  transition: transform 0.2s, box-shadow 0.2s;

  label{
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: #8892a0;
    margin-bottom: 4px;
  }
  p{
    font-size: 15px;
    font-weight: 600;
    color: #1a1a2e;
    margin: 0!important;
  }
}
.info-icon{
  width: 44px;
  height: 44px;
  background: rgba(236, 174, 32, 0.12);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  i{
    color: #ECAE20;
  }
}
.in-time{
  color: #666;
}

.dtls-two-col{
  display: grid;
  grid-template-columns: 1fr 360px;
  gap: 24px;
}
.section-box{
  background: #fff;
  border-radius: 8px;
  padding: 28px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  margin-bottom: 24px;


}
.sb-header{
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;

  label{
    font-size: 18px;
    font-weight: 700;
    color: #1a1a2e;
  }
}
.sb-icon{
  width: 36px;
  height: 36px;
  background: rgba(236, 174, 32, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  i{
    color: #ECAE20;
  }
}
.description-text{
  font-size: 15px;
  color: #4a4a6a;
  line-height: 1.8;

  i{
    margin-right: 4px;
  }
  .fa-check{
    color: #16c942;
  }
  .fa-times{
    color: #db3030;
    vertical-align: -1px;
  }
}
.show-all{
  font-weight: 600;
  font-size: 12px;
  letter-spacing: 1px;
  padding: 5px 26px;
  cursor: pointer;
  text-transform: uppercase;
  color: #8894a1;
  margin-top: 15px;
  display: inline-block;
}
.dtls-two-side > *{
  margin-bottom: 24px;
}
.side-card{
  background: #fff;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);

  p {
    font-size: 14px;
    color: #4a4a6a;
    line-height: 1.7;
    margin: 0;
  }
}
.side-label{
  font-size: 15px;
  font-weight: 700;
  color: #1a1a2e;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;

  i{
    color: #22c55e;
  }
}

.price-section {
  background: #1a1a2e;
  border-radius: 10px;
  padding: 32px;
  color: #fff;
  position: relative;
  overflow: hidden;
}
.price-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 8px;
}
.price-value {
  font-size: 42px;
  font-weight: 700;
  color: #ECAE20;
  margin-bottom: 4px;
  position: relative;
  z-index: 1;

  span {
    font-size: 18px;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.5);
    margin-left: 4px;
  }
}
.price-note {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  margin-bottom: 24px;
  word-spacing: 2px;
  letter-spacing: .6px;
}
.km-btn {
  width: 100%;
  padding: 16px;
  background: #ECAE20;
  color: #1a1a2e;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
  z-index: 1;
}


@media only screen and (max-width: 641px) {
}
</style>


// WEBPACK FOOTER //
// index.vue?314cc568